import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { APP_BASE_HREF } from '@angular/common';
import { ProjectModule } from './project/project.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DeviceModule } from './device/device.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserModule } from "./user/user.module";
import { CompanyModule } from "./company/company.module";
import { ReportModule } from "./report/report-module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TreeFlatOverviewComponent } from './report/shared/components/tree-flat-overview/tree-flat-overview.component';
import { ErrorEngineModule } from './error-engine/error-engine.module';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { AlarmService } from './project/shared/services/camera-alarm.service';
import { ReportingModule } from './reporting/reporting.module';
import { Chart } from 'chart.js';
import 'chartjs-adapter-date-fns';

@NgModule({
    declarations: [
        AppComponent,
        TreeFlatOverviewComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        DashboardModule,
        DeviceModule,
        SharedModule,
        BrowserAnimationsModule,
        ProjectModule,
        UserModule,
        CompanyModule,
        ReportModule,
        NgbModule,
        ErrorEngineModule,
        ReportingModule
    ],
    providers: [AlarmService,
        { provide: APP_BASE_HREF, useValue: '/avs-portal/' },
        provideRouter([], withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }))
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
